import { useTranslation } from "@/hooks/useTranslation";
import { useCreateSenderGroup } from "@/services";
import {
	Button,
	Dialog,
	DialogContent,
	DialogHeader,
	DialogScrollableArea,
	DialogTitle,
	Icon,
} from "@st-marketplace/ui";
import React from "react";
import { SenderGroupForm } from "./SenderGroupForm";
import type { SenderGroupFormData } from "./senderGroupForm.schema";

const SenderGroupFormCreate: React.FC = () => {
	const { t } = useTranslation();
	const createGroupMutation = useCreateSenderGroup();

	const [open, setOpen] = React.useState(false);

	const handleSubmit = async (data: SenderGroupFormData) => {
		await createGroupMutation.mutateAsync({
			body: {
				name: data.name,
				timezone: data.timezone,
				to_keep: data.use_global_setting ? null : data.to_keep ?? null,
				priority_usage: data.use_global_priority
					? null
					: data.priority_usage ?? null,
			},
		});
		setOpen(false);
	};

	return (
		<>
			<Button
				type="button"
				color="primary"
				className="w-full normal-case md:w-auto"
				startIcon={<Icon name="add-line" />}
				onClick={() => setOpen(true)}
			>
				{t("senderGroup.addButton")}
			</Button>

			<Dialog open={open} onOpenChange={setOpen}>
				<DialogContent className="w-full max-w-120">
					<DialogHeader>
						<DialogTitle>{t("senderGroup.addButton")}</DialogTitle>
					</DialogHeader>
					<DialogScrollableArea>
						<SenderGroupForm
							submitLabel={t("senderGroup.formSubmit")}
							initialValues={{
								name: "",
								timezone: "UTC",
								to_keep: null,
								use_global_setting: true,
								use_global_priority: true,
								priority_usage: null,
							}}
							loading={createGroupMutation.isPending}
							onSubmit={handleSubmit}
						/>
					</DialogScrollableArea>
				</DialogContent>
			</Dialog>
		</>
	);
};

export default SenderGroupFormCreate;
